import axios from 'axios'
import { useContext } from 'react'
import { useQuery } from 'react-query'

import SideNav from '../../../components/side-nav/SideNav'
import { SERVER_URL } from '../../../constants'
import { LanguageContext } from '../../../contexts/LanguageContext'
import { TranslatedWordsContext } from '../../../contexts/TranslatedWordsContext'

function CheckoutSideNav() {
  let menuCategories = []
  const { language } = useContext(LanguageContext)
  const { translatedWords } = useContext(TranslatedWordsContext)

  const fetchMenuItems = async () => {
    return await axios.get(`${SERVER_URL}/menu/${language?.code}`)
  }

  const {
    isLoading: menuIsLoading,
    isFetching: menuIsFetching,
    isError: menuIsError,
    data: menuData,
  } = useQuery('menuItems', fetchMenuItems)

  if (menuData) {
    menuCategories.push(
      menuData.data.map((item) => {
        return item.category
      }),
    )
    menuCategories = Array.from(new Set(menuCategories[0]))
    menuCategories = [translatedWords?.all, ...menuCategories.sort()]
  }

  if (menuIsError) console.error('Error getting menu data')

  return (
    <SideNav
      items={menuCategories}
      itemsIsLoading={menuIsLoading || menuIsFetching}
    />
  )
}

export default CheckoutSideNav
